<template>
  <div style="text-align: center;padding-top:20px;margin-top: -10px;" id="tenderInfo">
    <div style="text-align: left;display:inline-block;padding:10px 50px;width:1150px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招标信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="text-align: left;display:inline-block;padding:10px 0;width:1150px;">
      <div style="display: inline-block;width:80%;margin:0px 0 20px 10%;">
        <el-input placeholder="请输入招标项目关键词" v-model="pageParam0.title">
          <el-button slot="append" icon="el-icon-search" @click="getNoticeType0Data()">搜索</el-button>
        </el-input>
      </div>
      <el-table :data="noticeType0Data" border stripe style="width:1150px;margin:20px 0;"
                :header-cell-style="{color:'#000',fontSize:'16px'}" size="small">
        <el-table-column prop="name" label="项目名称">
          <template slot-scope="scope">
            <p @click="goTo(scope.row,1)" style="cursor: pointer;" class="titleHover">{{ scope.row.title }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="projectSn" label="项目编号" width="140"></el-table-column>
        <el-table-column label="公告类型" width="90">
          <template slot-scope="scope">
            {{ notice[scope.row.noticeTypeCode].name }}
          </template>
        </el-table-column>
        <el-table-column label="招标方式" width="100">
          <template slot-scope="scope">
            {{ way[scope.row.bidMethodCode].name }}
          </template>
        </el-table-column>
        <el-table-column prop="release_time" label="发布时间" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.publishDate ? scope.row.publishDate.substring(0, 10) : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="报名截止时间" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.deadlineDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="goTo(scope.row,1)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-show="noticeType0Data.length!=0" style="margin: 30px auto;" background layout="prev, pager, next"
                     :current-page="pageParam0.pageNum" :page-size="pageParam0.pageSize" :total="pageParam0.total" @current-change="getNoticeType0Data"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tender',
  data() {
    return {
      screenWidth: 1300,
      formSearch: {
        state: 1,
        notice: '',
        type: '',
        page: 1, //当前页
        limit: 10, //每页的条数
        total: 0, //总条数
        name: '',
        pages: 1,
      },
      noticeType0Data: [],
      pageParam0: {
        title: null,
        total: 0,
        pageNum: 1,
        pageSize: 10,
        tenantId: '214998',
      }
    }
  },
  methods: {
    getNoticeType0Data(currentPage) {
      this.pageParam0.pageNum = currentPage == undefined ? this.pageParam0.pageNum : currentPage;
      let param = `?pageNum=${this.pageParam0.pageNum}&pageSize=${this.pageParam0.pageSize}&tenantId=${this.pageParam0.tenantId}&title=${this.pageParam0.title ? '' + this.pageParam0.title : ''}` ;

      this.$axios.get(this.baseUrl4+'bidNotice/list' + param, this.pageParam0).then(response => {
        if (response.data.code != '200') {
          this.$alert(response.data.msg, '提示', {
            confirmButtonText: '确定'
          });
        } else {
          this.noticeType0Data = response.data.rows
          this.pageParam0.total = response.data.total
        }
      }).catch(function (error) {
        window.console.log(error)
      }); //ajax请求失败
    },
    goTo(row, page) {
      if (this.formSearch.page > 2) {
        this.$alert('查看更多信息,请联系我们注册账号。', '提示');
      } else {
        //localStorage.setItem('tenderId',val.row.tender_info_id);
        this.$router.push({
          path: '/tenderInfoContent',
          query: {
            id: row.id
          }
        })
      }

    }
  },
  beforeMount: function () {
    if ('val' in this.$route.query) {
      //搜索进入
      this.formSearch.name = this.$route.query.val;
    }
    this.getNoticeType0Data();

  },
  mounted() {
    this.bus.$emit('headerImg', [{
      src: require('@/assets/images/bk/招标信息.jpg'),
      href: ""
    }]);
    this.screenWidth = document.documentElement.clientWidth;
    window.addEventListener('resize', () => {
      this.screenWidth = document.documentElement.clientWidth;
    })

  }
}
</script>

<style scoped>
.titleInfo {
  margin: 20px 0;
}

.titleInfo span {
  margin-right: 10px;
  color: #909399;
}

.hoverSpan:hover {
  background-color: #0084C4;
  color: #fff;
}

#tenderInfo /deep/ .el-input__inner {
  border: #C0C4CC 1px solid;
}

#tenderInfo /deep/ .el-button {
  border: #C0C4CC 1px solid;
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.titleHover:hover {
  font-weight: 550;
}
</style>
